import React from "react";
import ProductTemplate from "../../ProductTemplate";
import s91Cover from "../../../assets/s91/S91Cover.png";
import s91a from "../../../assets/s91/s91a.webp";
import s91b from "../../../assets/s91/s91b.webp";
import s911 from "../../../assets/s91/s911.webp";
import s912 from "../../../assets/s91/s912.webp";
import s913 from "../../../assets/s91/s913.webp";
import s914 from "../../../assets/s91/s914.webp";
import s915 from "../../../assets/s91/s915.webp";
import s916 from "../../../assets/s91/s916.webp";
import s917 from "../../../assets/s91/s917.webp";
import s91sec1 from "../../../assets/s91/s91sec1.webp";
import s91sec2 from "../../../assets/s91/s91sec2.webp";

const S91 = () => {
  const data = {
    title: "ALUMIL S91",
    subtitle: "Hinged insulated system SMARTIA S91",
    description:
      "The system SMARTIA S91 offers the alternative for frames with concealed sash and fittings. This version is ideal for maximizing the natural light thanks to its significantly reduced visible aluminum face width. The system offers high thermal insulation and watertightness performances, which in combination with the high sound reduction make it ideal for the most demanding projects.",
    specifications: [
      { label: "WINDOW TYPE", value: "Hinged" },
      { label: "FRAME DEPTH", value: "91 mm" },
      { label: "U-VALUE", value: "from 0.67 to 1.1 W/m²K" },
      { label: "BURGLAR RESISTANCE", value: "RC2/RC3" },
      { label: "WATER TIGHTNESS", value: "CLASS E1650" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "up to 81 mm" },
      { label: "MINIMUM VISIBLE ALUMINIUM FACE HEIGHT", value: "93 mm" },
    ],
    renders: [s91Cover, s91a, s91b],
    typologies: [
      { image: s911, caption: "Odd number of vents on one side" },
      { image: s912, caption: "Odd number of vents plus door" },
      { image: s913, caption: "Odd number of vents on both sides (meeting stile)" },
      { image: s914, caption: "Odd number of vents on one side" },
      { image: s915, caption: "Corner construction with single door" },
      { image: s916, caption: "Corner construction with odd number of vents on both sides" },
      { image: s917, caption: "Odd number of vents on both sides (meeting stile)" },
    ],
    sections: [s91sec1, s91sec2],
    relatedFiles: [
      {
        label: "S91 System Specs",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/technical/supreme/s91-technical-brochures.pdf?sfvrsn=52f00dc9_43",
      },
      {
        label: "SUPREME Systems",
        link: "https://www.alumil.com/docs/default-source/knowledgebase/brochures/general/supreme-brochure-gr-en.pdf?sfvrsn=5bdefc43_90",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default S91;